/**
 * Convert input to a number (if it's a string) and round to two decimal places.
 * Returns a Number (not a formatted string). Returns NaN for non-numeric input.
 * @param {string|number} input
 * @returns {number}
 */
export function toTwoDecimalPlaces(input) {
    const num = typeof input === 'string' ? Number(input.trim()) : Number(input);
    if (!Number.isFinite(num)) return NaN;
    return num.toFixed(2);
}
